import { Mobile, iOS, Android, TRANSITION_END } from './core'
import Panels from './modules/panels'
import Grids from './modules/grids'
import './plugins/newsletter-form'
import './plugins/scroll-effect'
import './plugins/atelier-toolbar'
import './plugins/gallery'
import './plugins/colors'
import './plugins/position-hover'
import './plugins/duotone-hover'

$(function() {
  $.mlmi = {
    mobile: new Mobile('(max-aspect-ratio: 1 / 1), (max-width: 767px)', '(min-aspect-ratio: 1 / 1) and (min-width: 768px)'),
    isTouch: iOS() || Android(),
    panels: undefined,
  }

  let $body = $('body')

  /* Mobile class */
  $.mlmi.mobile.add(function() {
    $body.removeClass('--horizontal').addClass('--vertical')
  }, function() {
    $body.removeClass('--vertical').addClass('--horizontal')
  })

  /* Touch */
  if ($.mlmi.isTouch) {
    $('html').removeClass('no-touch').addClass('has-touch')
  } else {
    $body.on('touchstart', function() {
      $.mlmi.isTouch = true
      $body.off('touchstart')
    })
  }

  /* Load colors & show body */
  window.randomizeColors()
  $body.removeClass('d-none')

  /* Panels */
  $.mlmi.panels = Panels.init()

  /* Display intro */
  if (false && location.hostname === 'localhost') {
    $body.removeClass('--intro-animated').trigger('intro_played')
  } else if ($.mlmi.mobile.matchesMedia()) {
    $body.removeClass('--intro-animated').trigger('intro_played')
  } else {
    setTimeout(function() {
      let $logo = $('.panel__logo')
      $body.addClass('--intro-animated--phase-2')
      $logo.on(TRANSITION_END, function() {
        $logo.off(TRANSITION_END)
        setTimeout(function() {
          $body.removeClass('--intro-animated--phase-2')
          requestAnimationFrame(function() {
            $body.addClass('--intro-animated--phase-3')
            setTimeout(function() {
              $body.removeClass('--intro-animated --intro-animated--phase-3')
              $body.trigger('intro_played')
            }, 1250)
          })
        }, 200)
      })
    }, 250)
  }

  /* Content grids */
  let grids = Grids.init()

  /* Atelier toolbar */
  $('.atelier-toolbar').each(function() {
    $(this).AtelierToolbar()
  })

  /* Forms */
  $('.newsletter-form').each(function() {
    $(this).NewsletterForm()
  })

  /* Team scroll effect */
  $('.grid--style--team').ScrollEffect()
  // $('.grid--style--portfolio').ScrollEffect()

  /* Duotone hover */
  $('.card-panorama__image').each(function() {
    $(this).DuotoneHover()
  })

  /* Load more grid */
  $('button[data-load-more]').on('click', function() {
    $(this).fadeOut(150)
    $('.grid--style--' + $(this).data('load-more')).find('.grid__item').fadeIn(250)
  })
})
